import { render } from "./SpDataReport.vue?vue&type=template&id=46c6789e"
import script from "./SpDataReport.vue?vue&type=script&lang=js"
export * from "./SpDataReport.vue?vue&type=script&lang=js"

import "./SpDataReport.vue?vue&type=style&index=0&id=46c6789e&lang=scss"

import exportComponent from "/Users/user/Desktop/prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__